<template>
  <login-form go-to-route-name="Customers" />
</template>

<script>
import LoginForm from '@/components/partials/LoginForm'

export default {
  components: {
    LoginForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login/LoginPage.vue